const ShipmentCourierEnum = {
  FEDEX: 'FedEx',
  SHIPSMART: 'Shipsmart',
  '99MINUTOS': '99Minutos',
  LAPCOURIER: 'LAPCourier',
  CHILEXPRESS: 'Chilexpress',
};

export default ShipmentCourierEnum;
